<template>
    <v-modal-slot id="change-task-team-modal"
                  @accepted="editTaskTeam">
        <template v-slot:modal-title>
            Cambiar equipo
        </template>

        <template v-slot:modal-content>
            <div class="row user-form">
                <div class="col-12">
                    <div class="form-group">
                        <label class="form-label">Equipo: </label>

                        <select class="form-control" disabled v-if="teams.length === 0">
                            <option selected>- No existen equipos en la aplicación -</option>
                        </select>

                        <div class="input-group" v-else>
                            <v-select-jq aria-label="Equipo"
                                         parent-id="change-task-team-modal"
                                         placeholder="- Seleccionar -"
                                         ref="selectTeams"
                                         :options="teams"
                                         :value="selected_task.role_id"
                                         @update:modelValue="selected_task.role_id = $event">
                            </v-select-jq>

                            <button class="delete-date" @click="$refs.selectTeams.removeAll();"
                                    :disabled="!selected_task.role_id  ? true : null">
                                <span class="uq-icon bi-x-lg"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template v-slot:accept-button>
            Guardar
        </template>

        <template v-slot:close-button>
            Cerrar
        </template>
    </v-modal-slot>
</template>

<script>
import VModalSlot from "../../general/VModalSlot";
import VModal from "../../general/VModal";
import VSelectJq from "../../general/VSelectJQ";
import {getRoles} from "../../../helpers/requests/RequestsRoles";
import {updateTask} from "../../../helpers/requests/RequestsTasks";

export default {
    name: "TaskChangeTeamModal",
    components: {
        VSelectJq,
        VModalSlot,
        VModal
    },
    data() {
        return {
            selected_task: {},
            teams: [],
        }
    },
    props: {
        task: {
            type: Object,
            required: false,
        }
    },
    async mounted() {
        this.selected_task = this.task;
        await this.loadAvailableTeams();
    },
    methods: {
        formatRoleName(name) {
            return name.charAt(0).toUpperCase() + name.slice(1).replaceAll('_', ' ');
        },
        async loadAvailableTeams() {
            let teams = await getRoles();

            if (!teams.meta) {
                this.teams = Object.values(teams).map((team) => {
                    return {id: team.id, text: this.formatRoleName(team.name)};
                });
            }
        },
        async editTaskTeam() {
            try {
                if (!this.selected_task.role_id) {
                    this.task.role_id = null;
                } else {
                    this.task.role_id = this.selected_task.role_id;
                }

                await updateTask(this.selected_task);

                this.$store.dispatch('app/setToastMessage', 'Tarea asignada al equipo');

                this.$emit('task-team-updated');

                this.closeModal();
            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'Error al asignar la tarea al equipo');
            }
        },
        closeModal() {
            this.$emit('closed');
        }
    },
}
</script>
